module.exports = __webpack_public_path__ + "img/yoichi_banner.8890d50e.png";